import { render, staticRenderFns } from "./RequiredStepRegistration.vue?vue&type=template&id=311f4d9a&"
import script from "./RequiredStepRegistration.vue?vue&type=script&lang=js&"
export * from "./RequiredStepRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports